<app-new-footer
  *ngIf="showNewFooter"
  [footerLite]="footerLite"
  [footerError]="footerError"
  [isCDTConfig]="isCDTConfig"
  [isBiometrics]="isBiometrics"
></app-new-footer>
<app-old-footer
  *ngIf="!showNewFooter"
  [footerLite]="footerLite"
  [footerError]="footerError"
  [isCDTConfig]="isCDTConfig"
  [isBiometrics]="isBiometrics"
  [whiteHeader]="whiteHeader"
></app-old-footer>
